<div class="pay-methods-scope">
  <div class="pay-toolbar">
    <h2 class="pay-page-title">Payment methods</h2>
    <button type="button" class="account-cta" (click)="onAddCard()">
      Add New Card
    </button>
  </div>

  <article class="wallet-banner">
    <div class="wallet-brand">
      <img src="../../assets/Images/lucky-bucks-logo-1.png" alt="Lucky Bucks" class="wallet-logo">
    </div>
    <div class="wallet-details">
      <div *ngIf="isLoadingWallet" class="wallet-loading">
        <i class="fa fa-spinner fa-spin"></i>
        <p>Loading wallet balance...</p>
      </div>
      <div *ngIf="!isLoadingWallet" class="wallet-balance">
        <div class="wallet-balance-label">Available Balance</div>
        <div class="wallet-balance-value">{{ walletBalance | currency }}</div>
      </div>
      <p class="wallet-hint">
        <mat-icon>info</mat-icon>
        Use Lucky Bucks at checkout to pay for purchases.
      </p>
    </div>
  </article>

  <section class="saved-cards-section">
    <h3 class="pay-section-title">
      Saved cards
      <span *ngIf="savedCards.length">{{ savedCards.length }}</span>
    </h3>

    <div *ngIf="savedCards.length === 0" class="saved-cards-empty">
      No saved cards yet. Add one to check out faster.
    </div>

    <div class="cards-grid" *ngIf="savedCards.length > 0">
      <article
        class="saved-card"
        *ngFor="let card of savedCards; trackBy: trackById"
        [class.active]="card.isActive"
        [class.inactive]="!card.isActive"
        tabindex="0"
        (keyup.enter)="onEdit(card)">
        <header class="saved-card-header">
          <div class="brand-avatar" aria-hidden="true">
            <mat-icon>credit_card</mat-icon>
          </div>
          <div class="saved-card-identity">
            <h3 class="saved-card-name">{{ card.cardHolderName || 'Card' }}</h3>
            <p class="saved-card-number">{{ mask(card.cardNumber) }}</p>
          </div>
          <button mat-icon-button [matMenuTriggerFor]="cardMenu" [matMenuTriggerData]="{item: card}" aria-label="More actions">
            <mat-icon>more_vert</mat-icon>
          </button>
        </header>

        <div class="saved-card-body">
          <div class="saved-meta">
            <span class="saved-meta-label">Expiry</span>
            <span class="saved-meta-value">{{ card.cardExpiryMonth }}/{{ card.cardExpiryYear }}</span>
          </div>
          <div class="saved-meta">
            <span class="saved-meta-label">Added</span>
            <span class="saved-meta-value">{{ card.detailsAddedOn | date:'dd MMM yyyy' }}</span>
          </div>
          <div class="saved-meta">
            <span class="saved-meta-label">Status</span>
            <span class="saved-status" [class.saved-status--active]="card.isActive" [class.saved-status--inactive]="!card.isActive">
              {{ card.isActive ? 'Active' : 'Inactive' }}
            </span>
          </div>
        </div>
      </article>
    </div>
  </section>
</div>

<mat-menu #cardMenu="matMenu" xPosition="before">
  <ng-template matMenuContent let-item="item">
    <button mat-menu-item (click)="onEdit(item)">
      <mat-icon>edit</mat-icon><span>Edit</span>
    </button>
    <button mat-menu-item (click)="toggleActive(item)">
      <mat-icon>toggle_on</mat-icon><span>{{ item.isActive ? 'Set Inactive' : 'Set Active' }}</span>
    </button>
    <button mat-menu-item (click)="onDelete(item)">
      <mat-icon>delete</mat-icon><span>Delete</span>
    </button>
  </ng-template>
</mat-menu>
